import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { Button, Tabs } from 'antd';
import { SettingOutlined } from '@ant-design/icons/lib/icons';
import AppEmpty from '../AppEmpty';
import { useParams } from 'react-router-dom';
import { DeploymentsContext } from '../../core/context/DeploymentsContext';
import DeploymentsItem from '../../types/DeploymentsItem';
import ButtonWithOverlayDialog from '../common/ButtonWithOverlayDialog';
import BackupsList from './BackupsList';
import BackupsScheduleList from './BackupsScheduleList';
import { useHistory } from 'react-router';
import BackupSettingsModal from './BackupsSettingsModal';

export type UrlProps = {
    dataStoreUuid: string;
    projectUuid: string;
    tab: string;
};

function Backups(): ReactElement {
    const history = useHistory();
    const { dataStoreUuid, projectUuid, tab } = useParams<UrlProps>();
    const [deployment, setDeployment] = useState<DeploymentsItem | null>();
    const deploymentContext = useContext(DeploymentsContext);

    useEffect(() => {
        if (deploymentContext?.deployments && dataStoreUuid) {
            let deployment =
                deploymentContext.deployments.getByUuid(dataStoreUuid);
            setDeployment(deployment);
        }
    }, [deploymentContext]);

    return (
        <Tabs
            tabBarExtraContent={
                deployment && (
                    <ButtonWithOverlayDialog
                        button={
                            <Button
                                data-testid={`BackupSettings`}
                                icon={<SettingOutlined />}
                            >
                                Backup settings
                            </Button>
                        }
                        overlay={
                            <BackupSettingsModal deployment={deployment} />
                        }
                    />
                )
            }
            activeKey={tab || 'backups'}
            onChange={(tabKey: any) => {
                const tab = tabKey === 'backups' ? '' : `/${tabKey}`;
                history.push(
                    `/projects/${projectUuid}/data-stores/${dataStoreUuid}/backups${tab}`
                );
            }}
        >
            <Tabs.TabPane
                tab="All backups"
                key="backups"
                style={{ paddingTop: 20 }}
            >
                {(deployment && <BackupsList deployment={deployment} />) || (
                    <AppEmpty message="No datastore was retrieved" />
                )}
            </Tabs.TabPane>

            <Tabs.TabPane
                tab="Backup schedules"
                key="schedules"
                style={{ paddingTop: 20 }}
            >
                {(deployment && (
                    <BackupsScheduleList deployment={deployment} />
                )) || <AppEmpty message="No datastore was retrieved" />}
            </Tabs.TabPane>
        </Tabs>
    );
}

export default Backups;
